import React, { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import { authFetch } from '../utils/authFetch';

export default function ContactDiscountTerms({ contactId }) {
  const [config, setConfig] = useState(null);
  const [saved, setSaved] = useState(null);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const apply = data => {
    setSaved(data);
    setForm(data.terms || { percent: 0, days: 15, date_basis: 'credit_date' });
  };
  useEffect(() => {
    let alive = true;
    setConfig(null); setForm(null); setError(''); setMessage('');
    authFetch('/incasari-scont/config').then(async cfg => {
      if (!alive) return;
      setConfig(cfg);
      if (cfg.enabled && cfg.can_read && contactId) {
        const data = await authFetch(`/incasari-scont/clienti/${contactId}/conditii`);
        if (alive) apply(data);
      }
    }).catch(e => { if (alive) setError(e.message); });
    return () => { alive = false; };
  }, [contactId]);
  if (!config?.enabled || !config?.can_read) return null;
  const save = async () => {
    setError(''); setMessage('');
    if (form.percent === '' || !Number.isFinite(Number(form.percent)) || Number(form.percent) < 0 || Number(form.percent) >= 100 || form.days === '' || !Number.isInteger(Number(form.days)) || Number(form.days) < 0 || Number(form.days) > 365) {
      setError('Completati procentul intre 0 si 99.9999 si zilele intre 0 si 365.'); return;
    }
    setBusy(true);
    try {
      apply(await authFetch(`/incasari-scont/clienti/${contactId}/conditii`, { method: 'PUT', body: JSON.stringify({
        percent: Number(form.percent), days: Number(form.days), date_basis: form.date_basis,
        revision: saved.revision, reason: 'Conditii implicite actualizate din Contacte',
      }) }));
      setMessage('Conditiile de scont au fost salvate pentru facturile viitoare.');
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  };
  return <div className="border rounded p-3 mb-3">
    <h6>Conditii implicite de scont</h6>
    {!contactId && <p>Salvati contactul, apoi deschideti Editare pentru a completa conditiile de scont.</p>}
    {error && <Alert variant="danger">{error}</Alert>}
    {message && <Alert variant="success">{message}</Alert>}
    {form && <>
      <fieldset disabled={busy || !config.can_write}>
        <Row className="g-2">
          <Col><Form.Label htmlFor="contact-scont-percent">Scont (%)</Form.Label><Form.Control id="contact-scont-percent" type="number" min="0" max="99.9999" step="0.0001" value={form.percent} onChange={e => setForm({ ...form, percent: e.target.value })}/></Col>
          <Col><Form.Label htmlFor="contact-scont-days">Zile de scont</Form.Label><Form.Control id="contact-scont-days" type="number" min="0" max="365" step="1" value={form.days} onChange={e => setForm({ ...form, days: e.target.value })}/></Col>
        </Row>
        <Form.Label htmlFor="contact-scont-basis" className="mt-2">Data platii folosita la verificare</Form.Label>
        <Form.Select id="contact-scont-basis" value={form.date_basis} onChange={e => setForm({ ...form, date_basis: e.target.value })}>
          <option value="credit_date">Data creditarii contului</option><option value="value_date">Data valorii</option><option value="doc_date">Data documentului de incasare</option>
        </Form.Select>
        <Button type="button" className="mt-2" onClick={save}>Salveaza conditiile de scont</Button>
      </fieldset>
      <small className="text-muted d-block mt-2">Zile calendaristice de la emiterea facturii, separat de scadenta. Procentul 0 dezactiveaza scontul. Facturile existente raman neschimbate.</small>
    </>}
  </div>;
}
